import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig";

const deleteCaseStudy = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`/CaseStudies/${id}`);
    return data;
  } catch (error) {
    console.error("Error deleting case study:", error);
    throw error;
  }
};

const useDeleteCaseStudy = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCaseStudy,
    onSuccess: () => {
      queryClient.invalidateQueries(["caseStudies"]);
    },
    onError: (err) => {
      console.error("Delete case study mutation failed:", err);
    },
  });
};

export default useDeleteCaseStudy;

